/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------

==========================================================================================*/
import Vue from 'vue';

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },


  //////////////////////////////////
  updateLoading({commit}, payload){
    commit('UPDATE_LOADING', payload);
  },
  updateLoads({commit}, payload){
    commit('UPDATE_LOADS', payload);
  },

  ////////////////////////////////////////////////
  // SHOW ALERT
  ///////////////////////////////////////////////
  alertSuccess({ commit }, payload) {
      Vue.prototype.$vs.notify({
        time:3000,
        position: 'bottom-right',
        title: '',
        text: payload,
        color: 'success'
      });
      commit("ALERT_CLEAR");
  },
  alertError({ commit }, payload) {
    Vue.prototype.$vs.notify({
      time:3000,
      position: 'bottom-right',
      title: '',
      text: payload,
      color: 'danger'
    });
    commit("ALERT_CLEAR");
  },

  //Folder actions
  togglePopup({ commit }, payload) {
    commit('TOGGLE_POPUP', { type: payload.type, data: payload.data});
  },

  setReload({ commit }, f){
    commit('SET_RELOAD', f);
  },
  updateActiveNavBar({ commit }) {
    commit('UPDATE_ACTIVE_NAV_BAR');
  },
  alertNotification({ commit }, payload) {
    Vue.prototype.$vs.notify({
      time: 3000,
      position: 'top-center',
      title: payload.email_sender_full,
      text: payload.subject,
      color: 'primary'
    });
  }
}

export default actions
